import { Waiter } from "common/promises";
import { calculateScreen, MAXIMUM_HEIGHT } from "from-start/screen";
import { html, LitElement } from "lit-element";
import { styleMap } from "lit-html/directives/style-map";
export class ChatBot extends LitElement {
    constructor() {
        super();
        this.hasRendered = new Waiter();
        this.onResize = this.onResize.bind(this);
    }
    createRenderRoot() {
        return this;
    }
    async waitFirstRender() {
        await this.hasRendered.wait();
    }
    firstUpdated() {
        this.hasRendered.trigger();
    }
    onResize() {
        this.requestUpdate();
    }
    render() {
        const { viewport } = calculateScreen();
        const bottom = (MAXIMUM_HEIGHT - viewport.height) / 2;
        const topStyle = {
            top: `${bottom}px`,
            left: "0",
            right: "0",
        };
        const bottomStyle = {
            bottom: `${bottom}px`,
            left: "0",
            right: "0",
        };
        const contentStyle = {
            top: `${bottom}px`,
            bottom: `${bottom}px`,
            left: "0",
            right: "0",
        };
        return html `
      <jh-chat-bot-top class="absolute" style=${styleMap(topStyle)}>
      </jh-chat-bot-top>
      <jh-chat-bot-content
        class="absolute"
        style=${styleMap(contentStyle)}
      ></jh-chat-bot-content>
      <jh-chat-bot-bottom
        class="absolute"
        style=${styleMap(bottomStyle)}
      ></jh-chat-bot-bottom>
    `;
        // return html`<jh-chat-bot-top /> <jh-chat-bot-content />
        // <jh-chat-bot-bottom />`;
    }
}
customElements.define("jh-chat-bot", ChatBot);
//# sourceMappingURL=chatBot.js.map